export const BaseURL = `https://api.o2xc.capital`;
